export default __webpack_public_path__ + "static/media/proximiio.8f85174c.png";